module.exports = __webpack_public_path__ + "media/media/favicon/favicon-16x16-c4d677b6830361e9b0187ccea0e9d809.png";